export default "__VITE_ASSET__CsyateOS__"